<template>
<div class="container">
<mq-layout mq="PC">
  <div class="container">
    <div class="row" v-if="firstOneInGraph">
      <div class="col-3 rounded-top" :class="leftBarColorClass(color)">
      </div>
      <div class="col-9">
      </div>
   </div>
    <div class="row">
      <div class="col-3 grid" :class="[leftBarColorClass(color), firstOneInSeg ? 'firstOne' : 'afterOne']">
          <div class="checkpoint-style title-margin">{{ fields.checkpoint }}</div>
          <div class="bar1 bar-placement">
            <div class="bar2" :class="leftBarColorClass(color)"><div v-if="firstOneInSeg" class="title-style">{{ title }}</div></div>
            <div class="ball"></div>
          </div>
      </div>
      <div class="col-9">
    </div>
    </div>
     <div class="row">
      <div class="col-3 no-padding" :class="[leftBarColorClass(color), lastOneInSeg ? 'lastOne' : '']">
      </div>
      <div :class="lastOneInSeg ? 'lastOne' : ''" class="col-9 no-padding">
        <div class="flex-message" v-bind:style="this.flexBoxAlign" v-if="fields">
          <div>
            <img class="float-left img-margin" :src="fields.iconUrl" />
          </div>
          <div>
            <ctf-rich-text ref="checkpointText"
              v-if="fields.checkpointMessage"
              class="checkpoint-message-margin"
              :document="fields.checkpointMessage"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="lastOneInGraph">
      <div class="col-3 rounded-bottom" :class="leftBarColorClass(color)">
      </div>
      <div class="col-9">
      </div>
   </div>
  </div>
</mq-layout>
<mq-layout mq="mobile">
  <div class="container">
    <div class="row" v-if="firstOneInGraph">
      <div class="col-4 rounded-top-mobile" :class="leftBarColorClass(color)">
      </div>
      <div class="col-8">
      </div>
   </div>
      <div class="row">
      <div class="col-4 no-padding" :class="leftBarColorClass(color)">
      </div>
      <div class="col-8 no-padding">
        <div v-if="firstOneInSeg" class="title-style-mobile">{{ title }}</div>
      </div>
   </div>
      <div class="row">
      <div class="col-4 no-padding-right" :class="leftBarColorClass(color)">
       <div class="bar1-mobile">
            <div class="bar2-mobile" :class="leftBarColorClass(color)"></div>
            <div class="ball-mobile"></div>
        </div>
      </div>
      <div class="col-8">
      </div>
   </div>
    <div class="row">
      <div class="col-4 mobile" :class="[leftBarColorClass(color), firstOneInSeg ? 'firstOne' : 'afterOne']">
          <div class="checkpoint-style mobile">{{ fields.checkpoint }}</div>
      </div>
      <div class="col-8">
         <div class="flex-message mobile" v-if="fields">
          <div>
            <img class="float-left img-margin mobile" :src="fields.iconUrl" />
          </div>
          <div>
            <ctf-rich-text
              v-if="fields.checkpointMessage"
              class="checkpoint-message-margin"
              :document="fields.checkpointMessage"
            />
          </div>
        </div>
    </div>
    </div>
    <div class="row" v-if="lastOneInGraph">
      <div class="col-4 rounded-bottom-mobile" :class="leftBarColorClass(color)">
      </div>
      <div class="col-8">
      </div>
   </div>
  </div>
</mq-layout>
</div>
</template>

<script>
import { backgroundColorClass, textColorClass, leftBarColorClass } from '@/utils/helpers'
import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    mobile: 768, // also displays on tablet
    PC: Infinity
  }
})

export default {
  name: 'Checkpoint',
  components: {
  },
  props: {
    fields: {
      type: Object,
      default: null
    },
    assets: {
      type: Array,
      default: null
    },
    sysId: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    firstOneInSeg: {
      type: Boolean,
      required: true
    },
    firstOneInGraph: {
      type: Boolean,
      required: true
    },
    lastOneInSeg: {
      type: Boolean,
      required: true
    },
    lastOneInGraph: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      flexBoxAlign: { }
    }
  },
  methods: {
    backgroundColorClass,
    textColorClass,
    leftBarColorClass,
    determineHeight () {
      var checkpointSize = this.$refs.checkpointText.$el.clientHeight
      var alignString
      if (checkpointSize < 70) {
        alignString = 'center'
      } else {
        alignString = 'flex-start'
      }
      Vue.set(this.flexBoxAlign, 'align-items', alignString)
    }
  },
  mounted () {
    this.determineHeight()
  }
  // https://stackoverflow.com/questions/44948714/get-element-height-with-vuejs/44949482#answer-62037114
  // https://forum.vuejs.org/t/solved-this-refs-key-returns-undefined-when-it-really-is/1226
}
</script>

<style lang="scss" scoped>
@import "src/styles/variables";
.background {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
}

.row{
  margin-right: 0;
  margin-left:0;
}

.firstOne{
 padding-top:40px;
}

.afterOne{
  padding-top:0;
}

.no-padding, .container{
  padding:0;
}

.no-padding.lastOne{
  padding-bottom:20px;
}

.rounded-top {
 border-radius: 10px 10px 0 0;
}

.rounded-bottom {
 border-radius: 0 0 10px 10px;
}

.flex-message {
  display: flex;
  position:relative;
}

.img-margin {
  margin-left: 10px;
  height: 50px;
  width: 50px;
}

.checkpoint-message-margin {
  margin-left: 10px;
}

.title-margin {
  margin-right: 10px;
}

.title-style{
  font-size: 24pt;
  font-weight: bold;
  margin-left: 10px;
  margin-top:-60px;
  font-family: 'Open Sans', sans-serif;
  color: rgb(3, 63, 96);
}

.checkpoint-style {
  color: white;
  text-align:right;
  font-size: 21pt;
  font-weight: 500; //semibold
  line-height: 33px;
}

.grid{
  //position:relative;
  padding-right: 5%;
  padding-bottom:0;
}

.bar-placement{
 top: -50%;
 margin-right:-30%;
 // https://css-tricks.com/centering-css-complete-guide/
}

.bar1 {
  right: 0;
  width: 25%;
  height: 2px;
  border-radius: 100px;
  background-color: white;
  float: right;
  position: relative;
}

.bar2 {
  right: 0;
  margin-right: -1684%; //to reach into second column
  width: 1700%;
  height: 2px;
  border-radius: 100px;
  float: right;
  position: relative;
}

.ball {
  right: 0;
  width: 11px;
  height: 11px;
  border-radius: 100px;
  background-color: white;
  float: left;
  position: relative;
  bottom: 5px;
}

// -------MOBILE CLASSES------------
.firstOne.mobile{
 padding-top:0
}

.rounded-top-mobile {
 border-radius: 0 10px 0 0;
}

.rounded-bottom-mobile {
 border-radius: 0 0 10px 0;
}

.flex-message.mobile{
  flex-direction:column;
}
 .img-margin.mobile {
  margin-bottom:20px
}

.title-style-mobile{
    font-size: 18pt;
    font-weight: bold;
    margin-left: 10px;
    font-family: 'Open Sans', sans-serif;
    color: rgb(3, 63, 96);
}

.checkpoint-style.mobile {
  font-size: 16pt;
}

.no-padding-right{
  padding-right:0;
}

.bar1-mobile {
  right: 0;
  width: 25%;
  height: 2px;
  border-radius: 100px;
  background-color: white;
  float: right;
  position: relative;
}

.bar2-mobile {
  right: 0;
  margin-right: -825%; //to reach into second column
  width:825%;
  height: 2px;
  border-radius: 100px;
  float: right;
  position: relative;
}

.ball-mobile {
  right: 0;
  width: 11px;
  height: 11px;
  border-radius: 100px;
  background-color: white;
  float: left;
  position: relative;
  bottom: 5px;
}
</style>
